import { useTranslations } from "use-intl";

import { type THotelRoom } from "@/app/lib/types/types";

type HotelRoomTitleProps = Pick<THotelRoom, "name" | "board" | "occupancy">;

export const HotelRoomTitle = ({
  name,
  board,
  occupancy,
}: HotelRoomTitleProps) => {
  const t = useTranslations();

  return (
    <>
      {`${name} - ${board} - ${t("hotels.search.visitorsSumWithTypes", {
        adultsCount: occupancy.numberOfAdults,
        childrenCount: occupancy.numberOfChildren,
      })}
    `}
    </>
  );
};
